<template>
  <div>
    <div class="left-menu-inside" v-if="!isManager">
      <router-link
        :class="{ active: $route.name === 'QR-codes' }"
        :to="{ name: 'QR-codes' }"
        ><span class="icon"
          ><svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.4128 0H5.50459C5.17982 0 4.91743 0.284106 4.91743 0.635762V5.3245H0.587156C0.262385 5.3245 0 5.60861 0 5.96026V11.3642C0 11.7159 0.262385 12 0.587156 12H10.4954C10.8202 12 11.0826 11.7159 11.0826 11.3642V6.6755H15.4128C15.7376 6.6755 16 6.39139 16 6.03974V0.635762C16 0.284106 15.7376 0 15.4128 0ZM6.16514 1.35099H9.83486V5.3245H6.16514V1.35099ZM4.91743 10.649H1.24771V6.6755H4.91743V10.649ZM9.83486 10.649H6.16514V6.6755H9.83486V10.649ZM14.7523 5.3245H11.0826V1.35099H14.7523V5.3245Z"
              fill="#ed6b1c"
            ></path></svg></span>
        QR-codes
      </router-link>
<!--      <router-link-->
<!--        :class="{ active: $route.name === 'Сотрудники' }"-->
<!--        :to="{ name: 'Сотрудники' }"-->
<!--        ><span class="icon"-->
<!--          ><svg-->
<!--            width="17"-->
<!--            height="17"-->
<!--            viewBox="0 0 17 17"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <path-->
<!--              d="M14.6057 12.057C14.0924 11.5433 13.4926 11.124 12.8338 10.8184C13.7628 10.0657 14.3555 8.91728 14.3555 7.62939C14.3555 5.35712 12.4606 3.49296 10.1883 3.52783C7.95093 3.56269 6.14829 5.38583 6.14829 7.62939C6.14829 8.91728 6.74302 10.0657 7.66997 10.8184C7.01107 11.1238 6.41125 11.5431 5.8981 12.057C4.77837 13.1788 4.14263 14.6595 4.10161 16.2386C4.10107 16.2605 4.10491 16.2822 4.11291 16.3026C4.12091 16.323 4.1329 16.3416 4.14819 16.3572C4.16348 16.3729 4.18175 16.3854 4.20193 16.3939C4.22211 16.4024 4.24378 16.4067 4.26568 16.4067H5.41411C5.5023 16.4067 5.57613 16.337 5.57818 16.2488C5.61714 15.0594 6.09908 13.9458 6.94605 13.1009C7.37946 12.6652 7.89499 12.3197 8.46279 12.0846C9.03059 11.8494 9.63939 11.7292 10.254 11.731C11.5029 11.731 12.678 12.217 13.5619 13.1009C14.4068 13.9458 14.8887 15.0594 14.9297 16.2488C14.9318 16.337 15.0056 16.4067 15.0938 16.4067H16.2422C16.2641 16.4067 16.2858 16.4024 16.306 16.3939C16.3262 16.3854 16.3444 16.3729 16.3597 16.3572C16.375 16.3416 16.387 16.323 16.395 16.3026C16.403 16.2822 16.4069 16.2605 16.4063 16.2386C16.3653 14.6595 15.7295 13.1788 14.6057 12.057ZM10.254 10.2544C9.55259 10.2544 8.89224 9.98164 8.398 9.48535C8.14997 9.23927 7.95404 8.94574 7.82191 8.62229C7.68978 8.29884 7.62416 7.95209 7.62896 7.60273C7.63511 6.93007 7.90376 6.27998 8.37339 5.79804C8.86558 5.29355 9.52388 5.01259 10.2273 5.00439C10.9225 4.99824 11.5972 5.26894 12.0935 5.75498C12.6021 6.25332 12.881 6.91982 12.881 7.62939C12.881 8.33076 12.6083 8.98906 12.112 9.48535C11.8685 9.73 11.5789 9.92393 11.26 10.0559C10.9411 10.1879 10.5991 10.2554 10.254 10.2544ZM5.11675 8.1708C5.09829 7.99238 5.08804 7.81191 5.08804 7.62939C5.08804 7.30332 5.1188 6.98544 5.17622 6.67578C5.19058 6.60195 5.15161 6.52607 5.08394 6.49531C4.80503 6.37021 4.54869 6.19794 4.3272 5.98056C4.06622 5.72751 3.86085 5.42283 3.7242 5.08598C3.58755 4.74912 3.52262 4.38747 3.53355 4.02412C3.552 3.36581 3.81656 2.74033 4.27798 2.26865C4.78452 1.7498 5.46538 1.46679 6.18931 1.47499C6.84351 1.48115 7.47515 1.73339 7.95298 2.18046C8.11499 2.33222 8.25445 2.50038 8.37134 2.68085C8.41236 2.74443 8.49234 2.77109 8.56206 2.74648C8.923 2.62138 9.30445 2.5332 9.69615 2.49218C9.81099 2.47988 9.87662 2.35683 9.82535 2.25429C9.15884 0.935638 7.79712 0.0250906 6.22212 0.00048119C3.94781 -0.0343821 2.05288 1.82978 2.05288 4.09999C2.05288 5.38789 2.64556 6.53632 3.57456 7.28896C2.92241 7.59043 2.32154 8.00673 1.80064 8.52763C0.676809 9.64941 0.0410669 11.1301 5.12818e-05 12.7112C-0.000496082 12.7331 0.00334304 12.7549 0.0113425 12.7753C0.019342 12.7957 0.03134 12.8142 0.0466295 12.8299C0.0619189 12.8456 0.0801907 12.858 0.100368 12.8665C0.120545 12.875 0.142219 12.8794 0.164114 12.8794H1.3146C1.40279 12.8794 1.47661 12.8097 1.47866 12.7215C1.51763 11.532 1.99956 10.4185 2.84654 9.57353C3.44947 8.9706 4.18775 8.55224 4.9937 8.34921C5.07369 8.32871 5.12701 8.25283 5.11675 8.1708Z"-->
<!--              fill="#ed6b1c"-->
<!--            ></path></svg></span-->
<!--        >Сотрудники</router-link>-->
    </div>
  </div>
</template>

<script>
import { isManager } from "@/helpers/authHelper";

export default {
  name: "SideBar",
  data() {
    return { isManager: isManager() };
  },
};
</script>

<style>
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.left-side-item {
  margin-top: -1px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  padding: 5px;
}

.item-icon {
  width: 50px;
}

.left-menu-inside{
  display: flex;
  flex-direction: column;
}

</style>
